import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import { Box, Button, ButtonGroup, Card, Flex, FormControl, FormLabel, Heading, HStack, IconButton, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useColorModeValue as mode, Spacer, Stack, Text, useDisclosure, useRadio, useRadioGroup } from '@chakra-ui/react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SelectDatepicker } from 'react-select-datepicker';
import { urlNavigate } from '../../../helper/utils/navigation.js';
import { doAddMinor, doDeleteMinor, doHandleState, doSignIn /* doUploadImage */ } from '../../../redux/waiver/waiver.actions.js';

export const CartItem = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const minor = useSelector((s) => s?.waiver?.minor ?? []);
    const major = useSelector((s) => s?.waiver?.major ?? []);

    const handleMinor = (val) => {
        const a = [...minor, { ...val, statusCode: '0', isWaiver: '0', isNew: '1' }].map((el, idx) => ({ ...el, idx }));
        dispatch(doAddMinor(a));
    };

    const handleDelete = (idx) => {
        const filter = minor.filter((el) => el?.key !== idx?.key);
        dispatch(doDeleteMinor(filter));
    };

    const email = localStorage.getItem('email');
    useEffect(() => {
        dispatch(doSignIn({ email }, navigate));
    }, []);

    // const [selectedFile, setSelectedFile] = useState(null)

    // const onFileChange = e => setSelectedFile(e.target.files[0]);
    // const onFileUpload = () => {
    //   const file = selectedFile
    //   dispatch(doUploadImage(selectedFile))

    // };

    const handleSignout = () => {
        navigate(urlNavigate('membership'));
        dispatch(doHandleState('minor', []));
        dispatch(doHandleState('major', {}));
    };

    const brandCode = localStorage.getItem('brand');

    return (
        <Flex direction='column' justify='space-between' align='center'>
            <Stack spacing='8' borderWidth='1px' rounded='lg' padding='8' width='full'>
                <Stack spacing='6'>
                    <Flex justify='space-between' fontSize='sm'>
                        <Text fontSize='md' fontWeight='extrabold' color={mode('gray.600', 'gray.400')}>
                            Email : {email}
                        </Text>
                    </Flex>
                    <Flex justify='space-between' fontSize='sm'>
                        <Text fontSize='md' fontWeight='extrabold' color={mode('gray.600', 'gray.400')}>
                            Name : {major?.fullname ?? ''}
                        </Text>
                    </Flex>
                    <Flex justify='space-between' fontSize='sm'>
                        <Text fontSize='md' fontWeight='extrabold' color={mode('gray.600', 'gray.400')}>
                            Brand : {String(brandCode).toUpperCase()}
                        </Text>
                    </Flex>
                </Stack>
            </Stack>
            {minor.map((el) => (
                <>
                    <Card mt={1} px={1} width='full'>
                        <Flex minWidth='max-content' alignItems='center' gap='1'>
                            <Box p='2'>
                                <Heading size='md'>{el?.name}</Heading>
                                <Heading size='md'>{el?.birthDate}</Heading>
                                <Heading size='md'>{+el?.statusCode === 1 ? 'Member' : 'Regular'}</Heading>
                                <Heading size='md'>{+el?.isWaiver === 1 ? 'Waiver' : 'Minor'}</Heading>
                                <Heading size='md'>{el?.gender}</Heading>
                            </Box>
                            <Spacer />
                            <ButtonGroup gap='2' m={2}>
                                {/* <AddPicture onFileUpload={onFileUpload} onFileChange={onFileChange} /> */}
                                <IconButton isDisabled={+el?.statusCode === 1} onClick={() => handleDelete(el)} colorScheme='primary' aria-label='Delete' icon={<DeleteIcon />} />
                            </ButtonGroup>
                        </Flex>
                    </Card>
                </>
            ))}
            <Box>
                <AddChildren handleMinor={handleMinor} />
                <Box>
                    <Button size='lg' fontSize='md' width='100%' onClick={handleSignout}>
                        Back
                    </Button>
                </Box>
            </Box>
        </Flex>
    );
};

function AddChildren({ handleMinor }) {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const initialRef = useRef(null);
    const finalRef = useRef(null);

    const [name, setName] = useState('');
    const [birthDate, setBirthDate] = useState('');

    const [gender, setGender] = useState('');

    const onOk = () => {
        onClose();
        setBirthDate('');
        setName('');
        setGender('');
        handleMinor({
            name,
            birthDate,
            gender,
        });
    };

    const [value, setValue] = useState(null);

    const onDateChange = useCallback((date) => {
        setValue(date);

        const dateValue = new Date(date);
        const year = dateValue.getFullYear();
        const month = String(dateValue.getMonth() + 1).padStart(2, '0'); // `getMonth()` menghasilkan bulan dari 0-11
        const day = String(dateValue.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        setBirthDate(formattedDate);
    }, []);

    let today = new Date();

    // Kurangi 18 tahun
    let eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(today.getFullYear() - 18);

    // Format menjadi 'YYYY-MM-DD'
    let dateMin = eighteenYearsAgo.toISOString().split('T')[0];
    const minDate = new Date(dateMin);

    return (
        <>
            <Box my={4}>
                <Button colorScheme='teal' size='lg' fontSize='md' onClick={onOpen} width='100%'>
                    Add Kids
                </Button>
            </Box>

            <Modal initialFocusRef={initialRef} finalFocusRef={finalRef} isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Tambah Anak</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <FormControl>
                            <FormLabel>Children Name</FormLabel>
                            <Input ref={initialRef} placeholder='Nama' onChange={(e) => setName(e?.target.value)} value={name} />
                        </FormControl>

                        <FormControl mt={4}>
                            <FormLabel>Birth Date</FormLabel>
                            <SelectDatepicker onDateChange={onDateChange} selectedDate={value} minDate={minDate} />
                        </FormControl>
                        <FormControl mt={4}>
                            <FormLabel>Gender</FormLabel>
                            <RadioGender onChange={(e) => setGender(e)} />
                        </FormControl>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='blue' mr={3} onClick={onOk}>
                            Save
                        </Button>
                        <Button onClick={onClose}>Cancel</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
}

// 1. Create a component that consumes the `useRadio` hook
function RadioCard(props) {
    const { getInputProps, getRadioProps } = useRadio(props);

    const input = getInputProps();
    const checkbox = getRadioProps();

    return (
        <Box as='label'>
            <input {...input} />
            <Box
                {...checkbox}
                cursor='pointer'
                borderWidth='1px'
                borderRadius='md'
                boxShadow='md'
                _checked={{
                    bg: 'teal.600',
                    color: 'white',
                    borderColor: 'teal.600',
                }}
                _focus={{
                    boxShadow: 'outline',
                }}
                px={5}
                py={3}>
                {props.children}
            </Box>
        </Box>
    );
}

// Step 2: Use the `useRadioGroup` hook to control a group of custom radios.
// eslint-disable-next-line react/prop-types
function RadioGender({ onChange }) {
    const options = ['male', 'female'];

    const { getRootProps, getRadioProps } = useRadioGroup({
        name: 'framework',
        defaultValue: 'male',
        onChange: onChange,
    });

    const group = getRootProps();

    return (
        <HStack {...group}>
            {options.map((value) => {
                const radio = getRadioProps({ value });
                return (
                    <RadioCard key={value} {...radio}>
                        {value}
                    </RadioCard>
                );
            })}
        </HStack>
    );
}

// eslint-disable-next-line react/prop-types
function AddPicture({ onFileUpload, onFileChange }) {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const initialRef = useRef(null);
    const finalRef = useRef(null);

    const onOk = () => {
        onClose();
        onFileUpload();
    };

    return (
        <>
            <IconButton onClick={onOpen} aria-label='Edit' icon={<EditIcon />} />

            <Modal initialFocusRef={initialRef} finalFocusRef={finalRef} isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Add Photo</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <FormControl>
                            <FormLabel>File Name</FormLabel>
                            <Input type='file' ref={initialRef} placeholder='Nama' onChange={onFileChange} />
                        </FormControl>
                        <Text mt={2}>* Maximum 1 MB</Text>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='blue' mr={3} onClick={onOk}>
                            Save
                        </Button>
                        <Button onClick={onClose}>Cancel</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
}
